export default {
  common: {
    fields: {
      status: {
        label: 'สถานะ',
        choices: {
          active: 'เปิดใช้งานแล้ว',
          inActive: 'ยังไม่เปิดใช้งาน',
        },
      },
      image: {
        label: 'รูปภาพ',
        image_path: 'ลิ้งรูปภาพ',
        helper: 'อนุญาตเฉพาะภาพที่มีขนาดสูงสุดไม่เกิน 10 MB',
      },
      file: {
        helper: 'อนุญาตเฉพาะไฟล์ที่มีขนาดสูงสุดไม่เกิน 10 MB',
      },
      published_to: {
        label: 'เผยแพร่ไปยัง',
        choices: {
          all_branches: 'ทุกสาขา',
          specific_branch: 'บางสาขา',
        },
      },
      highlight: {
        label: 'เด่น',
        choices: {
          true: 'เด่น',
          false: 'ไม่เด่น',
        },
      },
      published: {
        label: 'เผยแพร่',
        choices: {
          true: 'เผยแพร่แล้ว',
          false: 'ยังไม่เผยแพร่',
        },
      },
      approved: {
        label: 'อนุมัติ',
        choices: {
          true: 'อนุมัติแล้ว',
          false: 'ยังไม่อนุมัติ',
        },
      },
      actionTypes: {
        label: 'การกระทำ',
        choices: {
          none: 'None',
          inapp: 'In-app',
          webview: 'Webview',
          external_browser: 'External Browser',
        },
      },
      specific_branches: {
        label: 'เลือกสาขา',
      },
      specific_key: {
        label: 'เลือก Key',
      },
      order: 'ลำดับ',
      fax: 'โทรสาร',
      address: {
        address: 'ที่อยู่',
        street: 'ถนน',
        postcode: 'รหัสไปรษณีย์',
        district: 'เขต / อำเภอ',
        sub_district: 'แขวง / ตำบล',
        province: 'จังหวัด',
      },
      date: {
        created_at: 'วันที่สร้าง',
        updated_at: 'แก้ไขล่าสุด',
        published_on: 'วันที่เผยแพร่',
        expired_on: 'วันที่หมดอายุ',
      },
      year: 'ปี',
      zone: 'โซน',
      longitude: 'ลองจิจูด',
      latitude: 'ละติจูด',
      // publish_note: 'คอนเทนท์ของคุณจะยังไม่ถูกเผยแพร่จนกว่าจะได้รับการอนุมัติ',
      publish_note: '',
      type: { label: 'ประเภท', choices: { common: 'ส่วนกลาง', branch: 'สาขา' } },
      target_link: {
        label: 'ลิงค์เป้าหมาย',
        choices: {
          public_news: 'ข่าวส่วนกลาง',
          privilege: 'สิทธิพิเศษ',
          external_browser: 'เบราว์เซอร์ภายนอก',
        },
      },
      action: {
        label: 'การกระทำ',
        choices: {
          none: 'ไม่ระบุ',
          link: 'ลิงค์',
        },
      },
      target_value: {
        label: 'ลิงค์เป้าหมาย',
      },
      public_news: {
        label: 'ข่าวส่วนกลาง',
        clear: 'ล้างค่า',
      },
      expired: {
        label: 'หมดอายุ',
        clear: 'Clear',
        text: 'หมดอายุ %{date}',
        choices: {
          true: 'หมดอายุ',
          false: 'ไม่หมดอายุ',
        },
      },
      direct_marketing_consents: 'เนื้อหาเกี่ยวข้องกับการตลาด',
      slug_th: {
        label: 'Slug (ไทย)',
      },
      slug_en: {
        label: 'Slug (อังกฤษ)',
      },
      has_slug: {
        label: 'Slug',
        choices: {
          true: 'กำหนดค่าแล้ว',
          false: 'ยังไม่กำหนดค่า',
        },
      },
    },
  },
}
